module.exports = __webpack_public_path__ + "img/screenshot.e9249d60.jpg";